// extracted by mini-css-extract-plugin
export default {"history":"lsf-history","history__action":"lsf-history__action","history__action_delete":"lsf-history__action_delete"};
    if(module.hot) {
      // 1637785521792
      var cssReload = require("/Users/nicholasrq/Git/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  